import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY in .env')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { autoRefreshToken: false, persistSession: false },
})

export const db = {
  getContent: () => supabase.from('content').select('*').single(),
  updateContent: (data) => supabase.from('content').update(data).eq('id', '00000000-0000-0000-0000-000000000001'),
  getItems: () => supabase.from('items').select('*').eq('active', true).order('order'),
  getAllItems: () => supabase.from('items').select('*').order('order'),
  getItem: (slug) => supabase.from('items').select('*').eq('slug', slug).single(),
  upsertItem: (item) => supabase.from('items').upsert(item),
  deleteItem: (slug) => supabase.from('items').delete().eq('slug', slug),
  getGallery: () => supabase.from('gallery').select('*').order('order'),
  upsertGallery: (item) => supabase.from('gallery').upsert(item),
  deleteGallery: (id) => supabase.from('gallery').delete().eq('id', id),
  getReservations: () => supabase.from('reservations').select('*').order('created_at', { ascending: false }),
  upsertReservation: (res) => supabase.from('reservations').insert(res).select().single(),
  updateReservation: (id, data) => supabase.from('reservations').update(data).eq('id', id),
  deleteReservation: (id) => supabase.from('reservations').delete().eq('id', id),
  getReviews: () => supabase.from('reviews').select('*').eq('published', true).order('created_at', { ascending: false }),
  getAllReviews: () => supabase.from('reviews').select('*').order('created_at', { ascending: false }),
  upsertReview: (rev) => supabase.from('reviews').insert(rev).select().single(),
  updateReview: (id, data) => supabase.from('reviews').update(data).eq('id', id),
  deleteReview: (id) => supabase.from('reviews').delete().eq('id', id),
  signIn: (email, password) => supabase.auth.signInWithPassword({ email, password }),
  signOut: () => supabase.auth.signOut(),
  getSession: () => supabase.auth.getSession(),
  onAuthChange: (cb) => supabase.auth.onAuthStateChange(cb),
}

export { getImageUrl, uploadImage, deleteImage, listImages, uploadFromUrl } from './storage'
export default supabase
